export default class Forms {
  constructor() {
    this.form = null;
    this.inputs = [];
  }

  init() {
    this.form = $("form");
    this.inputs = this.form.find("input, textarea");
    this.loadForm();
    this.inputFocus();
    this.errorCheck();
    this.uploadField();
    this.customSelect();
    this.saveForm();
    this.editForm();
  }

  inputFocus() {
    this.inputs.on("input cut/copy/paste change", (e) => {
      if (e.target.value.length) {
        $(e.target.parentNode).closest('.input-wrapper, .textarea-wrapper').addClass('has-value');
      } else {
        $(e.target.parentNode).closest('.input-wrapper, .textarea-wrapper').removeClass('has-value');
      }
    });
  }

  errorCheck() {
    document.addEventListener('wpcf7submit', function(event) {
      let form = $(event.target).find("form");
      let infos = form.find(".wpcf7-form-control-wrap");

      if(form.hasClass("sent")) {
        $(".input-wrapper, .textarea-wrapper, .upload-wrapper").each(function() {
          $(this).removeClass("has-value has-error");
        })
      }

      infos.each(function(i, el) {
        if($(el).children().length > 0) {
          $(el).closest('.input-wrapper, .textarea-wrapper, .upload-wrapper').addClass("has-error");
        } else {
          $(el).closest('.input-wrapper, .textarea-wrapper, .upload-wrapper').removeClass("has-error");
        }
      });

    }, false);
  }

  uploadField() {
    let field = this.form.find(".upload-wrapper input");

    field.on("input", (e) => {
      let parent = $(e.target.parentNode).closest('.js-upload');
      let filesPlaceholder = parent.find(".js-upload-files");
      let files = e.originalEvent.srcElement.files;
      let text = "";

      if(files.length > 0) {
        Object.values(files).forEach((file, i) => {
          text = text + file.name + (i < files.length - 1 ? ", " : "");
        });
        filesPlaceholder.html(text);
        parent.addClass("has-value");
      } else {
        text = "";
        filesPlaceholder.html(text);
        parent.removeClass("has-value");
      }
    })
  }

  customSelect() {
    let $selectParent = $('.js-custom-select');

    if(!$selectParent.length) return;

    $selectParent.each((i, parent) => {
      let $parent = $(parent);
      let $select = $parent.find('select');
      let $customSelect = $parent.find('.custom-select');
      let $placeholderText = $customSelect.find('.placeholder .text');
      let $selected = $select.find('option[selected]');

      let $itemsWrapper = $customSelect.find(".items");
      let $options = $select.find("option");

      if(!$options.length) return;

      $itemsWrapper.empty();

      // let longest = $options[0];

      $options.each((i, option) => {
        let value = $(option).val();
        let label = $(option)[0].label;
        let item = '<span class="item" data-value="' + value + '">' + label + '</span>';
        $itemsWrapper.append(item);
        // if(option.innerHTML.length > longest.innerHTML.length) longest = option;
      });

      // if(!$placeholderText.attr("style")) {
      //   let longestWidth = $itemsWrapper.find('.item[data-value="' + longest.value + '"]').width();
      //   $placeholderText.css("min-width", longestWidth);
      // }

      $customSelect.unbind("click");

      $customSelect.click(function(e) {
        $(this).toggleClass("open");
      });

      $customSelect.mouseleave(function(e) {
        $(this).removeClass("open");
      });

      let $items = $customSelect.find(".item");

      if($selected.length) {
        let $selectedItem = $itemsWrapper.find('.item[data-value="' + $selected[0].value + '"]');
        $selectedItem.addClass('active');
        $parent.addClass('has-value');
        $placeholderText.html($selectedItem.html());
      }

      $items.click(function(e) {
        let val = $(this).data("value");
        $placeholderText.html($(this).html());
        $items.removeClass('active');
        $(this).addClass('active');
        $parent.addClass('has-value');
        $options.removeAttr("selected");
        $select.find("option[value='" + val +"']").prop("selected", "selected");
        $select.val(val).trigger("change");
      });
    });
  }

  saveForm() {
    let $save = this.form.find(".js-save-form");

    $save.click((e) => {
      e.preventDefault();
      let formId = $(e.target).parents().find(".js-form")[0].id;
      let url = location.href;
      let id = `${url} ${formId}`;
      let formEls = e.target.form.elements;
      let data = {};

      for (const element of formEls) {
        if (element.name.length > 0 && element.type !== 'file' && element.type !== 'checkbox' && element.type !== 'radio') {
          data[element.name] = element.value;
        }
      }

      localStorage.setItem(id, JSON.stringify(data));
    });
  }

  loadForm() {
    this.form.each((i, form) => {
      let formId = form.id;

      if(formId) {
        let url = location.href;
        let id = `${url} ${formId}`;
        let formEls = form.elements;

        if (localStorage.getItem(id)) {
          const savedData = JSON.parse(localStorage.getItem(id));
          for (const element of formEls) {
            if (savedData && element.name in savedData) {
              if(element.type !== 'select-one' && element.type !== 'select-multiple') {
                $(element).closest('.input-wrapper, .textarea-wrapper').addClass('has-value');
                element.value = savedData[element.name];
              } else {
                let $selectParent = $(element).closest('.select-wrapper');
                let $placeholderText = $selectParent.find('.placeholder span');
                $selectParent.addClass('has-value');
                $selectParent.find(".item[data-value='" + savedData[element.name] + "']").addClass("active");
                $placeholderText[0].innerHTML = savedData[element.name];
                $(element).find('option[value="' + savedData[element.name] + '"]').prop('selected', true);
              }
            }
          }
        }
      }
    });
  }

  editForm() {
    let $edit = this.form.find(".js-edit-form");

    $edit.click((e) => {
      e.preventDefault();
      let textarea = $(e.target).parents().find(".js-form").find("textarea")[0];

      if(textarea.value.length) {
        textarea.focus();
      }
    });
  }
}


// WEBPACK FOOTER //
// ./static/js/components/Forms.js